import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { register } from 'swiper/element';

import ThemeProvider from '@/components/globals/ThemeProvider';
import AppRoutes from '@/pages/routes';
import { store } from '@/redux/store';
import { BUILD_NUMBER, ENV, SENTRY_KEY } from '@/settings';

import Auth from './components/globals/Auth';
import MaintenanceMessage from './components/globals/Layout/MaintenanceMessage';
import '@/helpers/localSorage';

Sentry.init({
  dsn: SENTRY_KEY,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay(), new Sentry.BrowserTracing()],
  environment: ENV,
  release: `build-version-${BUILD_NUMBER}`,
  replaysOnErrorSampleRate: 0.1,
  beforeSend(event) {
    const ignoreErrors = event.exception.values.every((err: any) => !err || err.ignoreLog || err.isAxiosError);

    if (ignoreErrors) {
      return null;
    }

    if (event.transaction && event.transaction.includes('tawk.to')) {
      return null;
    }

    if (!window.location.href.startsWith('https://')) {
      return null;
    }

    return event;
  },
  ignoreErrors: [
    'Object [object Object] has no method "updateFrom"',
    'Network Error',
    'Request aborted',
    /Request failed with status code .*/,
    'timeout of 0ms exceeded',
    'SecurityError: The operation is insecure.',
    'ResizeObserver loop limit exceeded',
    'NS_ERROR_NOT_INITIALIZED',
    'can\'t redefine non-configurable property "userAgent"',
    /.*Failed to execute 'removeChild' on 'Node'.*/,
    /.*The node to be removed is not a child of this node.*/,
    /Non-Error promise rejection captured with value: Object Not Found Matching Id.*/,
    /ibFindAllVideos is not defined/
  ],
  denyUrls: [/https:\/\/\w+\.eduzz\.com/],
  allowUrls: [/https:\/\/\w+\.nutror\.com/]
});

register();

function App() {
  if ((window as any).hj !== undefined) (window as any).hj('event', 'nutror-experience');

  return (
    <BrowserRouter>
      <Provider store={store}>
        <Auth>
          <ThemeProvider>
            <MaintenanceMessage />
            <AppRoutes />
          </ThemeProvider>
        </Auth>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
